import { TReactSelectOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces";

/**
 * Used to collect needed data for react-select to display all possible selections
 * Mostly used in react-select
 * array - can be any array
 */
const createReactSelectOptions = (
  array: any[],
  valueKey: string,
  labelKey: string
): TReactSelectOption[] =>
  array.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));

export default createReactSelectOptions;
